import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from '@firebase/auth';
import { Navigate } from 'react-router-dom';
import { auth } from '../firebase';

const NotFound: React.FC = () => {
  const [user, setUser] = useState<any | null | undefined>(undefined);
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  if (user === undefined) return null;
  // Redirect immediately: logged-in -> /home, guests -> /
  return user ? <Navigate to="/home" replace /> : <Navigate to="/" replace />;
};

export default NotFound;
